module.exports = __webpack_public_path__ + "static/media/2.c40c07a0.jpg";